import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {
  createEventOptions,
  editEventOptions,
  getEventOptionsById,
} from '../../../../Store/Actions/eventOptions';
import {createSelectionOptionsUtil} from '../../../../Util/commonUtility';
import EventOptionsFormComponent from '../../../../Components/AdminComponents/EventOptions/EventOptionsForm';
import {getEventsById} from './../../../../Store/Actions/events';
import {getAllEventOptionGroupsByQueryString} from './../../../../Store/Actions/eventOptionGroups';

const EventOptionsFormContainer = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const {eventId} = useParams();
  const {allEventOptionGroupsQueryData} = useSelector(
    ({eventOptionGroups}) => eventOptionGroups,
  );
  const {getEventsData} = useSelector(({events}) => events);
  const {getEventOptionsData} = useSelector(({eventOptions}) => eventOptions);
  const [editData, setEditData] = useState();
  const [eventsList, setEventsList] = useState([]);
  const [eventOptionGroupsList, setEventOptionGroupsList] = useState([]);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    if (getEventOptionsData) {
      setEditData(getEventOptionsData?.data);
    }
  }, [getEventOptionsData]);

  // Fetch only the event this option belongs to (add mode: :eventId param,
  // update mode: the fetched option's event_id) instead of loading every event.
  useEffect(() => {
    const currentEventId = eventId || editData?.event_id;
    if (currentEventId) {
      dispatch(getEventsById(currentEventId));
    }
  }, [dispatch, eventId, editData?.event_id]);

  useEffect(() => {
    if (allEventOptionGroupsQueryData) {
      setEventOptionGroupsList(
        createSelectionOptionsUtil(
          allEventOptionGroupsQueryData?.data?.eventOptionGroups,
          'id',
          'name',
        ),
      );
    } else {
      dispatch(
        getAllEventOptionGroupsByQueryString(
          {
            page: 1,
            pagecount: 100,
          },
          '',
          '',
          '',
        ),
      );
    }
  }, [allEventOptionGroupsQueryData?.data?.eventOptionGroups]);

  const postEventOptions = (Data) => {
    return dispatch(createEventOptions(Data, navigate));
  };

  const updateEventOptions = (Data, id) => {
    return dispatch(editEventOptions(Data, id, navigate));
  };
  const fetchEventOptionsById = async (id) => {
    dispatch(getEventOptionsById(id));
  };
  return (
    <div>
      <EventOptionsFormComponent
        postEventOptions={(Data) => postEventOptions(Data)}
        updateEventOptions={(Data, id) => updateEventOptions(Data, id)}
        fetchEventOptionsById={(id) => {
          fetchEventOptionsById(id);
        }}
        EditData={editData}
        eventsList={eventsList}
        currentEvent={getEventsData?.data}
        eventOptionGroupsList={eventOptionGroupsList}
        setEventOptionGroupsList={setEventOptionGroupsList}
        fetching={fetching}
        setFetching={setFetching}
      />
    </div>
  );
};

export default EventOptionsFormContainer;
